(function () {
  var includedAccessories = {
    'Camera included': {
      key: 'camera',
      label: 'Pioreactor onboard camera',
      url: 'products/camera-kit?variant=62368060670008'
    },
    'OLED display included': {
      key: 'oled-display',
      label: 'Pioreactor OLED display',
      url: 'products/pioreactor-oled-display'
    }
  };

  function getLocalizedStorefrontUrl(path) {
    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    return root + path;
  }

  function syncIncludesListItem(toggle) {
    var positiveValue = toggle.getAttribute('data-binary-option-positive-value');
    var accessory = includedAccessories[positiveValue];

    if (!accessory) {
      return;
    }

    var section = toggle.closest('.shopify-section');
    var includesList = section
      ? section.querySelector('#includes_list')
      : document.getElementById('includes_list');

    if (!includesList) {
      return;
    }

    var item = includesList.querySelector('[data-included-accessory="' + accessory.key + '"]');

    if (!toggle.checked) {
      if (item) {
        item.remove();
      }
      return;
    }

    if (item) {
      return;
    }

    item = document.createElement('li');
    item.setAttribute('data-included-accessory', accessory.key);

    var link = document.createElement('a');
    link.href = getLocalizedStorefrontUrl(accessory.url);
    link.textContent = accessory.label;

    item.appendChild(link);
    item.appendChild(document.createTextNode('.'));
    includesList.appendChild(item);
  }

  function syncBinaryCheckboxFromSelect(select) {
    var toggleId = select.getAttribute('data-binary-option-toggle-id');
    var toggle = document.getElementById(toggleId);

    if (!toggle) {
      return;
    }

    toggle.checked = select.value === toggle.getAttribute('data-binary-option-positive-value');
    syncIncludesListItem(toggle);
  }

  function syncBinarySelectFromCheckbox(toggle) {
    var selectId = toggle.getAttribute('data-binary-option-select-id');
    var select = document.getElementById(selectId);

    if (!select) {
      return;
    }

    var nextValue = toggle.checked
      ? toggle.getAttribute('data-binary-option-positive-value')
      : toggle.getAttribute('data-binary-option-negative-value');
    var nextOption = Array.prototype.find.call(select.options, function (option) {
      return option.value === nextValue;
    });

    if (!nextOption || nextOption.disabled) {
      syncBinaryCheckboxFromSelect(select);
      return;
    }

    select.value = nextValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initializeBinaryOptions(root) {
    var binarySelects = root.querySelectorAll('[data-binary-option-toggle-id]');

    Array.prototype.forEach.call(binarySelects, syncBinaryCheckboxFromSelect);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-binary-option-toggle]')) {
      syncBinarySelectFromCheckbox(event.target);
    } else if (event.target.matches('[data-binary-option-toggle-id]')) {
      syncBinaryCheckboxFromSelect(event.target);
    } else if (event.target.matches('[data-option-select]')) {
      initializeBinaryOptions(event.target.closest('form') || document);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeBinaryOptions(document);
    });
  } else {
    initializeBinaryOptions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeBinaryOptions(event.target);
  });
})();
